import { QueryFunctionContext } from '@tanstack/react-query'
import { GET } from '../../../redux/middleware/types'
import customerEndpoints from '../api/customerEndpoints'
import customerQueryKeys from '../queries/customerQueryKeys'
import integrationRequest from '../../../services/api/integrationRequest'
import { Customer } from '../../../types/customer/customer'

export const getCustomers = async ({
  queryKey: [{ companyId }],
  signal
}: QueryFunctionContext<ReturnType<(typeof customerQueryKeys)['list']>>): Promise<Customer[]> => {
  if (!companyId || companyId === 'undefined') return []
  const customers = await integrationRequest<Customer[]>({
    method: GET,
    url: customerEndpoints.accounting(),
    signal,
    params: {
      companyId
    }
  })
  // Backend returns numeric ids; normalize to string to match Customer.id and the rest of the app.
  return customers.map(customer => ({ ...customer, id: String(customer.id) }))
}
